
export async function copyToClipboard(text) {
  if(!text) {
    return
  }
  const str = text.toString()
  await navigator.clipboard.writeText(str)
}
